export default {
    init() {
        let article_sign_up = document.getElementById('article-sign-up');
        if(article_sign_up) {
            let article_header = article_sign_up.getElementsByClassName('sign-up__header')[0];
            let article_form = article_sign_up.getElementsByClassName('sign-up__form')[0];
            $('#mce-success-response').bind('DOMSubtreeModified', function(){
                this.style.backgroundColor = "Blue";
                // article_form.remove();
                article_form.style.display = "none";
                article_header.getElementsByTagName('h4')[0].innerHTML = "Thanks. You have now been added to the IntegratED mailing list."
            });
        }
    }
}